/* eslint-disable no-untranslated-string/no-untranslated-string */
const NO_DATA = '—';

const PHONE_NUMBER_EXP = /^\d{10}$/;
const PRICE_EXP = /^-?\d{0,6}(?:\.\d{0,2})?$/;
const NUMERIC_EXP = /^[0-9]*$/;
const FULL_NAME_EXP = /^[a-zA-Z]([-']?[a-zA-Z.]+)*( [a-zA-Z]([-']?[a-zA-Z.]+)*)+$/;
const EMAIL_EXP =
  // eslint-disable-next-line max-len,no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const DATE_EXP = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
const POST_EXP = /^\d{5}(?:[-\s]\d{4})?$/;
const PATH_EXP = /^[\w-]+$/;
const LOWERCASE_EXP = /^[a-z0-9_-]+$/;
const SLUG_EXP = /^[a-zA-Z0-9_-]*$/;
const URL_EXP =
  /^(https?:\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/;
const NON_DIGIT_PATTERN = /\D/g;
const NON_ALPHANUMERIC_PATTERN = /[^a-z0-9\s]+/gi;
const DIGIT_PATTERN = /\d+/g;

export {
  DATE_EXP,
  DIGIT_PATTERN,
  EMAIL_EXP,
  FULL_NAME_EXP,
  LOWERCASE_EXP,
  NON_ALPHANUMERIC_PATTERN,
  NON_DIGIT_PATTERN,
  NO_DATA,
  NUMERIC_EXP,
  PATH_EXP,
  PHONE_NUMBER_EXP,
  POST_EXP,
  PRICE_EXP,
  SLUG_EXP,
  URL_EXP,
};
